// extracted by mini-css-extract-plugin
export default {"CommentsInput":"CommentsInput_CommentsInput__k1a-A","IsViewingStream":"CommentsInput_IsViewingStream__MoIn-"};